<div style="display: block; padding-top: 20px">
  <div style="text-align: center">
    <p>Expedientes tramitados del {{desde}} al {{hasta}}</p>
  </div>

  <canvas baseChart
          [datasets]="lineChartData"
          [labels]="lineChartLabels"
          [options]="lineChartOptions"
          [colors]="lineChartColors"
          [legend]="lineChartLegend"
          [chartType]="lineChartType"

  ></canvas>

</div>

